import Accordion from 'react-bootstrap/Accordion';
import MenuInteremedioAceca from '../menuInteremedioAcerca';
function horarios() {
  return (
    <div>
      <Accordion defaultActiveKey={['0']} alwaysOpen>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Horario Nivel Inicial</Accordion.Header>
          <Accordion.Body>
            <h6>  Ubicación: Estrada 168, Santa Rosa </h6>
            <h6>   Horarios: 13.30 a 17.00</h6>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>Horario Nivel Primario</Accordion.Header>
          <Accordion.Body>
            <h6>Ubicación: Neuquén 745</h6>
            <h6>  Horario: 13.30 a 17.30 </h6>
            <h6>   Horario intensivo: 8.45 a 11.45 y 13.30 a 17.30</h6>

          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>Horario Nivel Secundario</Accordion.Header>
          <Accordion.Body>

            <h6> Horario de ingreso al Colegio: 7.30 hs.</h6>
            <h6>   Inglés Curricular: tienen 3 hs cátedra. Una clase de 12.10 a 12.50 y otra, de 12.10   a  13.30 hs.</h6>
            <h6>------------ </h6>
            <h6>  Inglés Intensivo: de lunes a jueves de 13.30 a 15.30 hs. </h6>
            <h6>  Educación Física: 2 veces por semana en contra-turno (a la tarde)
              Los horarios particulares de la jornada de la mañana, correspondientes a cada año, se informan previo al inicio de ciclo lectivo.
            </h6>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>


      <MenuInteremedioAceca />
    </div>

  );

}
export default horarios;



